import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { Form } from '../../../../vas/business-objects/form/form.model';
import { Group } from '../../../../vas/business-objects/group/group.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const groupDetachReducer = (
    state = initialState,
    action: actions.GroupDetach
): State => {

    if (!state.group.ids.find(id => id === action.payload.group.id)) {
        return state;
    }

    let form = state.form.entities[state.form.selected];
    let group = action.payload.group;

    if (!group || !form) {
        return state;
    }

    form = new Form({
        ...form,
        groups: form.groups.filter(id => id !== group.id)
    });

    group = new Group({
        ...group,
        forms: group.forms.filter(id => id !== form.id)
    });

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            forms: arrayPushUnique(state.dirtyIds.forms, form.id),
            groups: arrayPushUnique(state.dirtyIds.groups, group.id)
        },
        form: {
            ...state.form,
            entities: {
                ...state.form.entities,
                [form.id]: form
            }
        },
        group: {
            ...state.group,
            entities: {
                ...state.group.entities,
                [group.id]: group
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/group-detach.reducer.ts